module.exports = __webpack_public_path__ + "static/uxuidesignsofiamoraes-78d3b524932426e8761846073a2413d1.jpeg";